export default __webpack_public_path__ + "static/724-0e1bfb0109e934b041c5ce016b8dfb14.gif";